import validator from 'validator';

export const required = (v) => !!v || 'This field is required'
export const url = (v) => !!v && validator.isURL(v, { require_protocol: true }) || 'Please enter valid URL'

export default {
  required,
  url,
}
